var FilterGroupsModule = /** @class */ (function () {
    function FilterGroupsModule() {
    }
    return FilterGroupsModule;
}());
export { FilterGroupsModule };
